<template>
  <TabPanels
    :unstyled="true"
    :pt="passThrough"
    class="meridia-tab-panels"
    v-bind="$attrs"
  >
    <div
      class="meridia-tab-panels-inner flex flex-col flex-1 overflow-hidden w-full min-w-0"
      v-bind="getPt('inner', passThrough)"
    >
      <slot />
    </div>
  </TabPanels>
</template>

<script setup lang="ts">
import { computed, provide, toRef } from 'vue';
import TabPanels from 'primevue/tabpanels';
import { usePassThrough } from 'primevue/passthrough';
import type { PassThrough } from '@primevue/core';
import {
  MERIDIA_TAB_PANELS_KEEP_ALIVE,
  MERIDIA_TAB_PANELS_ANIMATED,
} from 'src/design_system/components/tab/types';
import type {
  MeridiaTabPanelsProps,
  MeridiaTabPanelsPassThroughOptions,
} from 'src/design_system/components/tab/types';
import { getPt } from 'src/design_system/components/utils';

const props = withDefaults(defineProps<MeridiaTabPanelsProps>(), {
  animated: false,
  keepAlive: false,
});

defineSlots<{ default: () => any }>();

provide(MERIDIA_TAB_PANELS_KEEP_ALIVE, toRef(props, 'keepAlive'));
provide(MERIDIA_TAB_PANELS_ANIMATED, toRef(props, 'animated'));

const defaultPt: MeridiaTabPanelsPassThroughOptions = {
  root: {
    class:
      'meridia-tab-panels-root flex flex-col flex-1 overflow-hidden w-full min-h-0',
  },
};

const passThrough = computed(
  () =>
    usePassThrough(props.pt, defaultPt, {
      mergeSections: true,
      mergeProps: true,
    }) as PassThrough<MeridiaTabPanelsPassThroughOptions>
);
</script>
